import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-page-non-trouvee',
    templateUrl: './page-non-trouvee.component.html',
    styleUrls: ['./page-non-trouvee.component.scss'],
    imports: [RouterLink]
})
export class PageNonTrouveeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
